"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactTransitionGroup = require("react-transition-group");

var _Notify = _interopRequireDefault(require("./Notify.style"));

var _NotifyItem = _interopRequireDefault(require("./NotifyItem"));

var _dec, _class;

let Notify = (_dec = (0, _reactJss.default)(_Notify.default), _dec(_class = class Notify extends _react.PureComponent {
  render() {
    const {
      value,
      onClose,
      className,
      classes,
      dataTestId
    } = this.props;
    const reversedValue = value.slice(0).reverse();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.notify, className),
      "data-testid": dataTestId
    }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, reversedValue.map(item => /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      key: item.id,
      classNames: {
        enter: classes.animEnter,
        enterActive: classes.animEnterActive,
        exit: classes.animExit,
        exitActive: classes.animExitActive
      },
      timeout: 500
    }, /*#__PURE__*/_react.default.createElement(_NotifyItem.default, (0, _extends2.default)({
      onClose: onClose
    }, item))))));
  }

}) || _class);
Notify.defaultProps = {
  onClose: () => {},
  value: []
};
var _default = Notify;
exports.default = _default;